<template>
  <!-- チケット購入詳細 -->
  <div class="column">
    <!-- チケット情報(ラベル) -->
    <h2 class="column-title">
      {{ $t("common.Tickets") }}
    </h2>

    <div class="column-body">
      <div class="ticket-card">
        <!-- 有効期限 -->
        <BAvailablePeriod
          v-if="book.user_started_at"
          :period="masterBook.valid_period"
          :start="book.user_started_at"
          :limit="limitedAtMinusStartHour"
        />
        <!-- book.user_started_atがない場合、book.available_started_atを使用 -->
        <!-- availableを使う場合は、valid_period:1daysでも終了日時を表示するので、isBeforeValid=trueで制御　-->
        <BAvailablePeriod
          v-else
          :period="masterBook.valid_period"
          :start="book.available_started_at"
          :limit="limitedAtMinusStartHour"
          :is-before-valid="true"
        />
        <!-- 有効期限 -->

        <!-- 購入枚数 -->
        <BgDivisionCount
          v-if="bookGroup.divisions_label"
          :label="bookGroup.divisions_label"
        />
        <!-- 購入枚数 -->

        <!-- 発駅 -->
        <BFromStationSelect
          v-if="book.price && book.price.from_station"
          :name="book.price.from_station.name"
        />
        <!-- 発駅 -->

        <!-- 料金 -->
        <BgMyTicketPaymentAmount
          :total-price="divisionCalTotalPrice"
          :is-visible-price="
            bookGroup.master_book_sales_corporation == null
              ? true
              : bookGroup.master_book_sales_corporation.visible_price
          "
        />
        <!-- 料金 -->

        <!-- 発売日 -->
        <BMyTicketReleaseDateDisp
          :date="book.publish_date"
          :is-visible-release-date="
            bookGroup.master_book_sales_corporation == null
              ? true
              : bookGroup.master_book_sales_corporation.visible_publish_date
          "
        />
        <!-- 発売日 -->

        <!-- 備考 -->
        <BMyTicketRemarksDisp
          v-if="book.owner_profile"
          :remarks="book.owner_profile"
        />
        <!-- 備考 -->
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";

import bookGroupService from "@/services/bookGroup";
import myTicketsCommonService from "@/services/common/myTickets";

export default {
  name: "TheMyTicketPurchaseDetails",
  setup() {
    const store = useStore();

    const masterBook = computed(() => store.getters["ticketing/masterBook"]);
    const bookGroup = computed(() => store.getters["ticketing/bookGroup"]);
    const book = computed(() => store.getters["ticketing/book"]);
    const divisionCalTotalPrice = computed(() =>
      bookGroupService.calTotal(bookGroup.value)
    );
    const limitedAtMinusStartHour = computed(() => {
      // book.user_XXX_atがある場合
      if (book.value.user_started_at) {
        return myTicketsCommonService.getDiffLimitedAtMinusStartHour(
          book.value.user_limited_at,
          masterBook.value.start_hour
        );
        // book.user_XXX_atがない場合
      } else {
        return myTicketsCommonService.getDiffLimitedAtMinusStartHour(
          book.value.available_limited_at,
          masterBook.value.start_hour
        );
      }
    });

    return {
      masterBook,
      book,
      bookGroup,
      divisionCalTotalPrice,
      limitedAtMinusStartHour,
    };
  },
};
</script>
<style lang="scss" scoped>
.column-body {
  width: 100%;
}
.column {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  align-items: start;

  .column-title {
    margin: 18px 0 5px 0;
    font-size: 15px;
    font-weight: bold;
    color: #777777;
  }
}
</style>
